import { Tooltip } from '@mui/material'
import React from 'react'
import { useTranslate } from 'react-admin'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import HalfStepNumberInput from 'ui-shared/WrappedInputs/HalfStepNumberInput'

const PhysicalKeyInfoSection: React.FC = () => {
  const translate = useTranslate()
  return (
    <>
      <LocalizedInputText source="fullAddress" fullWidth />

      <Tooltip
        title={translate('tooltip.hint.experienceDuration')}
        style={{ marginRight: '24px' }}
      >
        <HalfStepNumberInput
          source="minDuration"
          label="form.fields.minDuration"
        />
      </Tooltip>

      <Tooltip title={translate('tooltip.hint.experienceDuration')}>
        <HalfStepNumberInput
          source="maxDuration"
          label="form.fields.maxDuration"
        />
      </Tooltip>
    </>
  )
}

export default PhysicalKeyInfoSection
